import { registerPage } from '@zillow/client-profiler-interface-cs';
import { logError } from '@zg-rentals/log-error';
import { MIN_LG } from '@/src/lib/breakpoints';

export function registerClientProfilerPage(pageName: string) {
  if (typeof window === 'undefined') return;

  const platform = window.matchMedia(MIN_LG).matches ? 'desktop' : 'mobile';

  try {
    registerPage({
      pageName,
      environment: process.env.NODE_ENV,
      platform,
    });
  } catch (e) {
    logError({
      error: e,
      errorType: 'ClientProfilerRegistrationError',
      context: { pageName },
    });
  }
}
